export default "icons-photoproducts"